import { ReactElement } from 'react';
import { LayoutType } from '@sandtech-hub-monorepo/ui-kit';

export enum RouteAccess {
  PRIVATE = 'private',
  PUBLIC = 'public',
}

export const AppRoutesPaths = {
  Home: '/',
  Learners: '/learners',
  Program: '/program/:programId',
  Learning: '/learning',
  Programs: '/programs',
  Settings: '/settings',
  Transcript: '/transcript',
  PaymentFAQS: '', // TODO: Fill this in

  //   Auth Routes
  Login: '/login',
  Logout: '/logout',
  SignUp: '/sign-up',
  ConfirmSignUp: '/sign-up-confirmation',
  ResetPassword: '/reset-password',
  CreatePassword: '/create-password',
  OauthToken: '/oauth/token',

  // Misc
  NotFound: '*',
};

export interface IRouteDefinition {
  path: string;
  name?: string;
  element: ReactElement;
  layout: LayoutType;
}
